import ProductCard from './ProductCard';

export const RoutineStep = ({ 
  stepNumber,
  title,
  description,
  products = []
}) => {
  return (
    <div data-testid={`routine-step-${stepNumber}`} className="py-8 md:py-12 border-b border-[#E5E5E5] last:border-b-0">
      {/* Step Header */}
      <div className="flex items-start gap-4 md:gap-6 mb-6">
        <span className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-[#3A4D39] text-white font-heading text-lg md:text-xl font-semibold">
          {stepNumber}
        </span>
        <div>
          <h3 className="font-heading text-xl md:text-2xl font-semibold text-[#1C1C1C] mb-2">
            {title}
          </h3>
          <p className="text-[#374151] text-sm md:text-base leading-relaxed">
            {description}
          </p>
        </div>
      </div>
      
      {/* Recommended Products */}
      {products.length > 0 && (
        <div className="ml-0 md:ml-16 mt-6">
          <p className="text-xs tracking-widest uppercase font-medium text-[#6B7280] mb-4">
            Recommended Products
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {products.map((product, index) => (
              <ProductCard key={index} {...product} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default RoutineStep;
